export * from './Items/types';
export * from './Definitions/types';

export type CmsConfiguration = {
  cmsInternalHandlerLambdaArn: string;
  tenantId?: string;
};
